import React, { useState } from "react";
import {
  Text,
  View,
  Platform,
  StyleSheet,
  TouchableOpacity,
} from "react-native";

import appStyles from "../../../appStyles";
import AppTheme from "../../AppTheme";
import IntegrationIcons from "../../common/icons/integrations";
import ImageComponent from "../../common/ImageComponent";
import IntegrationItemDetails from "./IntegrationItemDetails";

export default function IntegrationItem({
  controller,
  item = {},
  isActive = false,
  onItemSelected = () => {},
}) {
  const [showEgg, setShowEgg] = useState(false);

  const onItemPressed = () => {
    if (item.isAvailable) {
      onItemSelected(controller, item, isActive);
    } else {
      setShowEgg(true);
    }
  };

  return (
    <TouchableOpacity style={appStyles.borderBottom} onPress={onItemPressed}>
      {showEgg ? (
        <View style={styles.soonContainer}>
          <Text style={styles.soon}>SOON!</Text>
          <IntegrationIcons.EggIcon />
        </View> /* : !isActive ? null : item.hasAutoTrack ? (
        <ImageComponent
          image={require("../../../../assets/integrations/wand.png")}
          style={styles.statusIcon}
        />
      ) : (
        <ImageComponent
          image={require("../../../../assets/integrations/lightbulb.png")}
          style={styles.statusIcon}
        />
      ) */
      ) : null}

      <View style={styles.row}>
        {item.iconTag ? (
          <item.iconTag style={[styles.icon]} onPress={onItemPressed} />
        ) : item.icon ? (
          <ImageComponent image={item.icon} style={styles.icon} />
        ) : null}
        <View style={styles.info}>
          <Text style={styles.itemName}>{item.name}</Text>
          {isActive ? (
            <IntegrationItemDetails controller={controller} item={item}/>
          ) : (
            <Text style={styles.description} numberOfLines={2}>
              {item.description}
            </Text>
          )}
        </View>
      </View>
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  row: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: "row",
    height: 80,
    paddingLeft: 6,
  },
  info: {
    flex: 1,
  },
  itemName: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.175,
    color: AppTheme.almostBlack,
  },
  description: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-Regular",
    }),
    fontWeight: "300",
    fontSize: 12,
    lineHeight: 14,
    letterSpacing: 0.5,
    color: AppTheme.almostBlack,
  },
  icon: {
    width: 60,
    height: 60,
    marginRight: 12,
  },
  statusIcon: {
    position: "absolute",
    right: 6,
    top: 8,
    width: 20,
    height: 20,
  },
  egg: {
    height: 20,
    width: 20,
  },
  soonContainer: {
    position: "absolute",
    right: 6,
    top: 8,
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
  },
  soon: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: AppTheme.DEFAULT_COLOR,
  },
});
